module.exports = __webpack_public_path__ + "media/casana-modal_720p.a606fc45.mp4";